<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	.top
		width:100%;
		position: relative;
		.top-img
			width:100%
			height:408px
		.top-main
			position: absolute;
			top:79px;
			left:24%;
			.top-list
				display:flex;
				flex-direction:column;
				align-items:center;
				.top-main-img
					width:210px;
					height:41px;
					margin-bottom:34px;
				.top-main-desc
					width:456px;
					height:180px;
					font-size:16px;
					font-weight:400;
					color:rgba(255,255,255,1);
					line-height:30px;
					text-align:left;
			.top-video
				width:534px;
				height:373px;
				// background:#000;
				position: absolute;
				top:45px;
				left:105%;
	.tag
		text-align:center;
		.tag-top
			margin-top:100px;
			.tag-top-title
				height:59px;
				font-size:42px;
				font-weight:400;
				color:rgba(7,19,54,1);
				line-height:59px;
			.tag-top-desc
				margin-top:14px;
				height:22px;
				font-size:16px;
				font-weight:400;
				color:rgba(7,19,54,0.4);
				line-height:22px;
			.tag-top-desc1
				margin:14px auto;
				width:640px;
				height:40px;
				font-size:14px;
				font-weight:400;
				color:rgba(7,19,54,0.4);
				line-height:20px;
		.tag-list
			display:flex;
			flex-wrap: wrap;
			justify-content:center;
			margin-top:60px;
			padding:0px 15%;
			.tag-lists
				margin:0 10px;
				display:flex;
				align-items:center;
				margin-bottom:60px;
				width:25%;
				cursor:pointer;
				.tag-img
					width:64px;
					height:64px;
					margin-right:20px;
				.tag-name
					height:28px;
					font-size:20px;
					font-weight:400;
					color:rgba(7,19,54,1);
					line-height:28px;
		.banner-list
			width:1200px;
			height:391px;
			margin:30px auto;
			background:rgba(255,255,255,1);
			box-shadow:0px 2px 20px 0px rgba(225,225,225,0.5);
			border-radius:10px;
			.banners
				height:331px;
				.banner-img
					width:1146px;
					height:331px;
		.law
			display:flex;
			justify-content:center;
			position: relative;
			.l-list
				text-align:center;
				margin:53px 20px;
				position: relative;
				z-index:1;
				.l-img
					width:117px;
					height:117px;
					border-radius:80px;
				.l-isvip
					position: absolute;
					width:27px;
					height:27px;
					right:10px;
					bottom:75px;
				.l-name
					height:25px;
					font-size:18px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:25px;
					margin-top:13px;
					display:flex;
					justify-content:center;
					align-items:center;
					.l-name-desc
						height:25px;
						line-height:25px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow:ellipsis;
					.name-img
						width:16px;
						height:18px;
						margin-left:6px;
				.l-speciality
					margin:0 auto;
					width:83px;
					height:28px;
					line-height:28px;
					background:rgba(248,248,248,1)
					border-radius:15px;
					margin-top:6px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,1);
			.l-lists
				width:429px;
				height:230px;
				background:rgba(255,255,255,1);
				box-shadow:0px 0px 10px 0px rgba(39,81,203,0.21);
				border-radius:5px;
				position: absolute;
				top:30px;
				z-index:10;
				display:flex;
				.hover-list
					text-align:center;
					margin:25px 20px;
					position: relative;
					cursor:pointer;
					.l-img
						width:117px;
						height:117px;
						border-radius:80px;
					.l-isvip
						position: absolute;
						width:27px;
						height:27px;
						right:10px;
						bottom:60px;
					.l-name
						height:25px;
						font-size:18px;
						font-weight:500;
						color:rgba(7,19,54,1);
						line-height:25px;
						margin-top:13px;
						display:flex;
						justify-content:center;
						align-items:center;
						.l-name-desc
							height:25px;
							line-height:25px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow:ellipsis;
						.name-img
							width:16px;
							height:18px;
							margin-left:6px;
					.l-speciality
						margin:0 auto;
						width:83px;
						height:28px;
						line-height:28px;
						background:rgba(248,248,248,1);
						border-radius:15px;
						margin-top:6px;
						font-size:14px;
						font-weight:400;
						color:rgba(7,19,54,1);
				.hover-r
					margin:25px 0px;
					text-align:left;
					width:272px;
					.hover-title
						height:22px;
						font-size:16px;
						font-weight:500;
						color:rgba(7,19,54,1);
						line-height:22px;
					.hover-titlelist
						overflow-y: auto;
						height:85%;
						width:95%;
						padding-top:10px;
						.hover-name
							cursor:pointer;
							height:20px;
							font-size:14px;
							font-weight:400;
							color:rgba(7,19,54,1);
							line-height:20px;
							margin-bottom:10px;
							width:100%;
							white-space:nowrap;
							overflow:hidden;
							text-overflow:ellipsis;
</style>
<template>
  <div class="main">
  	<div class="top">
  		<img src="/static/img/banner_course.png" class="top-img">
  		<div class="top-main">
  			<div class="top-list">
    			<img src="/static/img/logo_course.png" class="top-main-img">
    			<div class="top-main-desc">企业法务通是弘商法律云面向中小企业推出的法律服务品牌，针对企业面临各种的法律风险，以企业合规为主线，打造六大合规系列的实操性法律培训课程，另外根据行业需求，如金融、电子商务、服务贸易、制造业等行业进行合规管理培训，通过讲座、论坛、沙龙等活动形式帮助企业提升合规管理能力，确保企业和各行业持续、稳定和高效经营与发展。</div>
    		</div>
    		<div class="top-video">
	    		<video height="310" width="534" src="https://honsenflagoss.honsenflag.com/video/course_video.mp4" controls></video>
	    	</div>
    	</div>
  	</div>
  	<div class="tag">
  		<div class="tag-top">
  			<div class="tag-top-title">企业合规课程</div>
  			<div class="tag-top-desc">- 开设70多期企业法务通课程 线上线下参与人数3万多人 -</div>
  		</div>
  		<div class="tag-list">
	  		<div v-for="item in list" class="tag-lists" @click="toMoreCourse(item.id)">
	  			<img :src="item.img" class="tag-img">
	  			<div class="tag-name">{{item.name}}</div>
	  		</div>
  		</div>
  	</div>
  	<div class="tag">
  		<div class="tag-top">
  			<div class="tag-top-title">活动现场</div>
  			<div class="tag-top-desc1">弘商法律云目前注册律师达到3000多名，针对不同类型、不同规模的企业所产生的不同的法律问题平台律师具备丰富的实战经验，提供专业的法律服务</div>
  		</div>
  		<div class="banner-list">
  			<div style="padding-top:30px;">
	            <el-carousel trigger="click" class="banners" height="331px" arrow="always">
	              <el-carousel-item v-for="(item,index) in bannerList" :key="index">
	                <img :src="item.url" v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}" class="banner-img">
	              </el-carousel-item>
	            </el-carousel>
            </div>
        </div>
  	</div>
  	<div class="tag">
  		<div class="tag-top">
  			<div class="tag-top-title">金牌讲师</div>
  			<div class="tag-top-desc1">- 开设70多期企业法务通课程 线上线下参与人数3万多人 -</div>
  		</div>
  		<div class="law">
  			<div v-for="(item , index) in lawList">
  				<div class="l-list" @mouseenter="hoverChange(index,true)">
	  				<img :src="$avatarHash(item.id)" class="l-img">
	  				<img v-if="item.vip_status == 1" src="/static/img/isviplawyer.png" class="l-isvip">
	  				<div class="l-name"><div class="l-name-desc">{{item.real_name || item.name}}</div><img src="/static/img/islawyer.png" class="name-img"></div>
	  				<div class="l-speciality">{{item.tag_name[0]}}</div>
  				</div>
  				<div class="l-lists" v-if="item.isHover" @mouseleave="hoverChange(index,false)">
  					<div class="hover-list" @click="$router.push({name: 'personalCenter', params: {id: item.id}})">
	    				<img :src="$avatarHash(item.id)" class="l-img">
			    		<img v-if="item.vip_status == 1" src="/static/img/isviplawyer.png" class="l-isvip">
			    		<div class="l-name"><div class="l-name-desc">{{item.real_name || item.name}}</div><img src="/static/img/islawyer.png" class="name-img"></div>
			    		<div class="l-speciality">{{item.tag_name[0]}}</div>
	    			</div>
	    			<div class="hover-r">
	    				<div class="hover-title">主讲课程 （{{item.course_list.length}}）</div>
	    				<div class="hover-titlelist">
	    					<div v-for="items in item.course_list" class="hover-name" :title="items.title" @click="toCourse(items.id)">{{items.title}}</div>
	    				</div>
	    			</div>
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
export default {
  name: 'LegalCourse',
  data () {
    return {
      list:[
      	{img:'/static/img/course_icon1.png',name:'劳动法与人力资源管理',id:1},
      	{img:'/static/img/course_icon2.png',name:'合同法与供应链管理',id:2},
      	{img:'/static/img/course_icon3.png',name:'公司法与股权管理',id:3},
      	{img:'/static/img/course_icon4.png',name:'知识产权保护',id:5},
      	{img:'/static/img/course_icon5.png',name:'税法与财务管理',id:4},
      	{img:'/static/img/course_icon6.png',name:'企业合规管理',id:6}
      ],
      bannerList:[
        {url:'/static/img/course_banner1.png'},{url:'/static/img/course_banner2.png'},{url:'/static/img/course_banner3.png'}
      ],
      lawList:[],
    }
  },
  mounted(){
  	this.getlawList();
  },
  methods:{
  	//鼠标的滑动事件
  	hoverChange(index,status){
  		this.lawList[index].isHover = status;
  	},
  	getlawList(){
  		let url = 'wxm/course/getGmct';
  		this.$ajax('get',url,res=>{
  			// console.log('123123123123',res);
  			res.data.forEach((val) =>{
				val.isHover = false;
			});
  			this.lawList = res.data;
  		})
  	},
  	toCourse(id){
  		this.$router.push({path:'/course/' + id})
  	},
  	toMoreCourse(id){
  		this.$router.push({path:'/moreCourse',query:{id:id}});
  	},
  }
}
</script>


// WEBPACK FOOTER //
// src/components/legalCourse/legalCourse.vue